function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4409",
    viewBox: "0 0 79.374996 79.375002",
    height: 300,
    width: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-217.62499)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2217",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 49.297713,228.94085 c 0,5.23276 -9.474552,28.23598 -9.474552,28.23598 0,0 -9.474554,-23.00322 -9.474554,-28.23598 0,-5.23275 4.242154,-9.47455 9.474554,-9.47455 5.233104,0 9.474552,4.2418 9.474552,9.47455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2219",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 26.5566,230.51142 c 3.699932,3.70029 13.266561,26.66577 13.266561,26.66577 0,0 -22.965481,-9.56663 -26.665414,-13.26692 -3.7002862,-3.69993 -3.7002862,-9.69892 0,-13.3985 3.700286,-3.70064 9.698919,-3.70028 13.398853,-3.4e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2221",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 11.587181,247.70263 c 5.232752,0 28.23598,9.47456 28.23598,9.47456 0,0 -23.003228,9.47455 -28.23598,9.4742 -5.2327532,0 -9.4749062,-4.2418 -9.4745532,-9.4742 0,-5.23311 4.2418,-9.47456 9.4745532,-9.47456"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2223",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 13.157747,270.44339 c 3.700286,-3.69993 26.665414,-13.2662 26.665414,-13.2662 0,0 -9.566275,22.96547 -13.266561,26.66506 -3.699934,3.70028 -9.69892,3.70028 -13.3985,0 -3.7006392,-3.70029 -3.7006392,-9.69857 -3.44e-4,-13.39886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2225",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 30.348607,285.41316 c 3.54e-4,-5.23275 9.474554,-28.23597 9.474554,-28.23597 0,0 9.474904,23.00322 9.474552,28.23597 0,5.23276 -4.2418,9.47456 -9.4742,9.4742 -5.233458,0 -9.474906,-4.24144 -9.474906,-9.4742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2227",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 53.08972,283.84225 c -3.699932,-3.69994 -13.266559,-26.66506 -13.266559,-26.66506 0,0 22.965479,9.56592 26.665759,13.2662 3.69994,3.70029 3.69994,9.69927 0,13.39886 -3.70099,3.70064 -9.69927,3.70028 -13.3992,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2229",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 68.05949,266.65139 c -5.23275,-2.7e-4 -28.236329,-9.4742 -28.236329,-9.4742 0,0 23.003579,-9.47491 28.236329,-9.47491 5.23276,2.6e-4 9.47456,4.24215 9.4742,9.47455 0,5.23346 -4.24144,9.47456 -9.4742,9.47456"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2231",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 66.48857,243.91027 c -3.70028,3.69993 -26.665409,13.26692 -26.665409,13.26692 0,0 9.566275,-22.96584 13.266209,-26.66612 3.70028,-3.69958 9.69927,-3.69958 13.3992,0 3.70064,3.70099 3.70029,9.69927 0,13.3992"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2233",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 49.297361,228.94085 c 0,5.2324 -9.4742,28.23634 -9.4742,28.23634 0,0 -9.474906,-23.00394 -9.474906,-28.23634 3.52e-4,-5.23275 4.242506,-9.4749 9.474552,-9.47455 5.233813,0 9.474906,4.2418 9.474554,9.47455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2235",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.559078,235.18396 c 0,-2.58374 2.094442,-4.67783 4.677833,-4.67783 0.299154,0 0.590902,0.0307 0.874536,0.0847 0.119943,-0.65616 0.186266,-1.21567 0.186266,-1.64994 0,-5.23275 -4.241448,-9.47455 -9.474552,-9.47455 -5.2324,0 -9.474906,4.2418 -9.474906,9.47455 0,0.42016 0.06173,0.95638 0.174273,1.58468 0.12841,-0.0102 0.25682,-0.0194 0.387702,-0.0194 2.583392,0 4.678185,2.09409 4.678185,4.67783 0,1.80869 -1.027993,3.37432 -2.529768,4.1529 2.799998,8.21478 6.764514,17.83997 6.764514,17.83997 0,0 3.901721,-9.47314 6.697486,-17.64382 -1.73355,-0.6851 -2.961569,-2.37173 -2.961569,-4.34905"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2237",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 26.913611,238.98408 c -1.827389,-1.82703 -1.827036,-4.78896 0,-6.61564 0.211314,-0.21167 0.439561,-0.39617 0.678039,-0.55845 -0.379237,-0.54892 -0.727781,-0.99165 -1.03505,-1.29857 -3.699934,-3.69993 -9.698567,-3.70029 -13.398853,3.4e-4 -3.7002862,3.69958 -3.7002862,9.69892 -3.44e-4,13.39921 0.297392,0.29704 0.720019,0.63253 1.243894,0.9973 0.08326,-0.0981 0.167923,-0.19544 0.259998,-0.28822 1.827036,-1.82668 4.789311,-1.82703 6.615994,0 1.27882,1.27882 1.659114,3.11291 1.147586,4.72511 7.788628,3.82869 17.398294,7.83202 17.398294,7.83202 0,0 -3.939471,-9.45762 -7.74065,-17.21238 -1.709915,0.74153 -3.771194,0.41733 -5.168899,-0.98073"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2239",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 17.830289,253.44127 c -2.583745,2.6e-4 -4.678186,-2.09444 -4.677834,-4.67819 -3.44e-4,-0.2988 0.03069,-0.5909 0.08431,-0.87418 -0.656166,-0.11995 -1.215319,-0.18662 -1.649588,-0.18627 -5.2327492,0 -9.4745492,4.24145 -9.4745492,9.47456 -3.53e-4,5.2324 4.2418,9.4749 9.4745532,9.4749 0.420158,-2.6e-4 0.95638,-0.0621 1.584677,-0.17462 -0.01023,-0.12842 -0.0194,-0.25683 -0.01976,-0.38735 0,-2.58375 2.094794,-4.67854 4.678186,-4.67854 1.808692,0 3.373967,1.02834 4.152547,2.52977 8.215137,-2.8 17.840326,-6.76416 17.840326,-6.76416 0,0 -9.473141,-3.90208 -17.644181,-6.69749 -0.684741,1.73355 -2.371725,2.96192 -4.348691,2.96157"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2241",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 21.630058,270.08674 c -1.826683,1.82703 -4.788958,1.82668 -6.615641,-2.7e-4 -0.211314,-0.21096 -0.39617,-0.43921 -0.558448,-0.67769 -0.548569,0.37924 -0.991305,0.72743 -1.298222,1.0347 -3.7002862,3.70029 -3.7002862,9.69857 3.44e-4,13.39885 3.69958,3.70029 9.698919,3.70064 13.398852,8e-4 0.297039,-0.2974 0.632531,-0.72038 0.997303,-1.2439 -0.09807,-0.0836 -0.195086,-0.16827 -0.287867,-0.26035 -1.827036,-1.82703 -1.827036,-4.78896 0,-6.61599 1.27882,-1.27882 3.11256,-1.65876 4.724753,-1.14759 3.82905,-7.78863 7.832021,-17.39794 7.832021,-17.39794 0,0 -9.457621,3.93912 -17.212029,7.7403 0.741539,1.71026 0.417336,3.77154 -0.981075,5.16925"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2243",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 36.087245,279.1697 c 2.64e-4,2.5841 -2.094442,4.67854 -4.678188,4.67819 -0.298802,2.6e-4 -0.590902,-0.0307 -0.873829,-0.0847 -0.119946,0.65652 -0.186973,1.21568 -0.186621,1.64994 0,5.23276 4.241448,9.4742 9.474906,9.4742 5.2324,2.7e-4 9.474552,-4.24144 9.474552,-9.4742 0,-0.42015 -0.06209,-0.95637 -0.17427,-1.58502 -0.128413,0.0106 -0.257175,0.0198 -0.387705,0.0201 -2.583743,0 -4.678185,-2.09479 -4.677833,-4.67854 -2.65e-4,-1.80834 1.027996,-3.37361 2.529065,-4.15254 -2.799644,-8.21478 -6.764161,-17.83997 -6.764161,-17.83997 0,0 -3.902075,9.47314 -6.697488,17.64417 1.73355,0.68475 2.962275,2.37138 2.961572,4.34834"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2245",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 52.73236,275.36994 c 1.82774,1.82703 1.82739,4.78895 0,6.61564 -0.21061,0.21166 -0.43921,0.39617 -0.67734,0.55844 0.37924,0.54893 0.72708,0.99166 1.0347,1.29823 3.69993,3.70028 9.69821,3.70064 13.3992,0 3.69994,-3.69959 3.70029,-9.69892 0,-13.39921 -0.29703,-0.29704 -0.72001,-0.63218 -1.24389,-0.9973 -0.0836,0.0984 -0.16792,0.19544 -0.26,0.28822 -1.82738,1.82668 -4.78931,1.82668 -6.61599,-2.7e-4 -1.27917,-1.27846 -1.65876,-3.11255 -1.14794,-4.72475 -7.788272,-3.82905 -17.397939,-7.83166 -17.397939,-7.83166 0,0 3.939469,9.45761 7.74065,17.21202 1.709912,-0.74189 3.771194,-0.41769 5.168549,0.98073"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2247",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 61.81568,260.9131 c 2.58445,-2.6e-4 4.67854,2.09409 4.67818,4.67819 2.7e-4,0.29845 -0.0307,0.59055 -0.0843,0.87383 0.65617,0.11994 1.21533,0.18697 1.64995,0.18627 5.23275,0 9.4742,-4.2411 9.4742,-9.47456 2.6e-4,-5.2324 -4.24145,-9.47455 -9.47456,-9.47455 -0.42015,0 -0.95638,0.0617 -1.58432,0.17427 0.01,0.12841 0.019,0.25683 0.0194,0.38735 -2.7e-4,2.5841 -2.09444,4.67854 -4.67854,4.67819 -1.80799,2.6e-4 -3.37361,-1.028 -4.15219,-2.52942 -8.214776,2.79965 -17.840318,6.76452 -17.840318,6.76452 0,0 9.473142,3.90207 17.644178,6.69713 0.68474,-1.73355 2.37173,-2.96192 4.34834,-2.96122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2249",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 58.01626,244.26764 c 1.82704,-1.82775 4.78896,-1.82739 6.61564,0 0.21167,0.21096 0.39617,0.4392 0.55845,0.67768 0.54892,-0.37923 0.99131,-0.72707 1.29822,-1.03505 3.70029,-3.69993 3.70064,-9.69821 0,-13.3992 -3.69993,-3.69958 -9.69927,-3.69994 -13.39956,3.4e-4 -0.29703,0.29704 -0.63217,0.72037 -0.99695,1.24389 0.0977,0.0836 0.19544,0.16793 0.28787,0.26 1.82704,1.82704 1.82704,4.78931 -2.6e-4,6.616 -1.278469,1.27882 -3.112209,1.65876 -4.724403,1.14758 -3.829489,7.78864 -7.832106,17.39831 -7.832106,17.39831 0,0 9.457619,-3.93947 17.212029,-7.74101 -0.74154,-1.70956 -0.41734,-3.77119 0.98107,-5.16854"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2251",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 46.50583,237.26147 c 0,3.69076 -6.682669,19.91536 -6.682669,19.91536 0,0 -6.682671,-16.2246 -6.682671,-19.91536 0,-3.69076 2.992263,-6.68267 6.682671,-6.68267 3.691112,0 6.682669,2.99191 6.682669,6.68267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2253",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 30.466082,238.36919 c 2.60985,2.60985 9.357079,18.808 9.357079,18.808 0,0 -16.197792,-6.74759 -18.807642,-9.35744 -2.60985,-2.60985 -2.60985,-6.84106 0,-9.45056 2.60985,-2.60985 6.840714,-2.60985 9.450563,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2255",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 19.907797,250.49452 c 3.690408,0 19.915364,6.68267 19.915364,6.68267 0,0 -16.224956,6.68231 -19.915364,6.68231 -3.690761,0 -6.683022,-2.99191 -6.682669,-6.68231 0,-3.69112 2.991908,-6.68267 6.682669,-6.68267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2257",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 21.015519,266.53391 c 2.60985,-2.6095 18.807642,-9.35672 18.807642,-9.35672 0,0 -6.746875,16.19779 -9.357079,18.80728 -2.609849,2.60985 -6.840713,2.60985 -9.450563,0 -2.60985,-2.60985 -2.60985,-6.84071 0,-9.45056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2259",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 33.14049,277.09255 c 2.65e-4,-3.69076 6.682671,-19.91536 6.682671,-19.91536 0,0 6.683021,16.2246 6.682669,19.91536 0,3.69076 -2.991908,6.68267 -6.682317,6.68231 -3.691466,0 -6.683023,-2.99155 -6.683023,-6.68231"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2261",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 49.180238,275.98447 c -2.609498,-2.60949 -9.357077,-18.80728 -9.357077,-18.80728 0,0 16.198139,6.74687 18.807639,9.35672 2.6102,2.60985 2.6102,6.84107 0,9.45056 -2.60985,2.61021 -6.840712,2.60985 -9.450562,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2263",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 59.73887,263.8595 c -3.69076,-2.6e-4 -19.915709,-6.68231 -19.915709,-6.68231 0,0 16.224949,-6.68303 19.915709,-6.68303 3.69077,2.7e-4 6.68268,2.99226 6.68232,6.68267 0,3.69112 -2.99155,6.68267 -6.68232,6.68267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2265",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 58.6308,247.81975 c -2.6095,2.60985 -18.807639,9.35744 -18.807639,9.35744 0,0 6.747579,-16.1985 9.357077,-18.808 2.60985,-2.60985 6.841062,-2.60985 9.450562,0 2.6102,2.60985 2.6102,6.84071 0,9.45056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2267",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 46.505478,237.26147 c 0,3.69041 -6.682317,19.91572 -6.682317,19.91572 0,0 -6.683023,-16.22531 -6.683023,-19.91572 2.65e-4,-3.69076 2.992615,-6.68302 6.682669,-6.68267 3.691821,0 6.683023,2.99191 6.682671,6.68267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2269",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 42.458057,241.66484 c 0,-1.82245 1.477433,-3.29953 3.299531,-3.29953 0.21096,0 0.416984,0.0219 0.616657,0.0596 0.08467,-0.46284 0.131585,-0.8569 0.131585,-1.16346 0,-3.69076 -2.991557,-6.68267 -6.682669,-6.68267 -3.690408,0 -6.683023,2.99191 -6.683023,6.68267 0,0.29633 0.04374,0.67451 0.123119,1.11795 0.09067,-0.008 0.181329,-0.0141 0.273404,-0.0141 1.822096,0 3.299529,1.47708 3.299529,3.29953 0,1.27565 -0.724958,2.37984 -1.78435,2.92912 1.975205,5.79402 4.771321,12.58287 4.771321,12.58287 0,0 2.752019,-6.68126 4.723694,-12.44459 -1.222727,-0.48295 -2.088798,-1.67287 -2.088798,-3.0674"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2271",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 30.717613,244.34525 c -1.288698,-1.2887 -1.288343,-3.37785 0,-4.66619 0.149225,-0.14958 0.310092,-0.2794 0.478367,-0.39406 -0.267407,-0.38699 -0.51294,-0.6992 -0.729898,-0.91581 -2.609849,-2.60985 -6.840713,-2.60985 -9.450563,0 -2.60985,2.6095 -2.60985,6.84107 -3.44e-4,9.45092 0.209903,0.20955 0.508,0.44591 0.877711,0.70344 0.05856,-0.0692 0.117828,-0.13794 0.183092,-0.2032 1.288697,-1.28835 3.377847,-1.2887 4.666544,0 0.9017,0.90205 1.169811,2.19569 0.809625,3.33269 5.493456,2.70051 12.271022,5.52415 12.271022,5.52415 0,0 -2.778479,-6.67068 -5.45959,-12.14015 -1.206148,0.52282 -2.659943,0.29422 -3.645958,-0.69179"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2273",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 24.311169,254.54194 c -1.82245,2.6e-4 -3.299883,-1.47709 -3.29953,-3.29954 -3.44e-4,-0.2106 0.02187,-0.41662 0.05962,-0.61665 -0.462844,-0.0847 -0.85725,-0.13159 -1.163461,-0.13123 -3.690761,0 -6.682669,2.99155 -6.682669,6.68267 -3.44e-4,3.6904 2.991908,6.68266 6.682669,6.68266 0.29598,0 0.674511,-0.0437 1.1176,-0.12311 -0.0074,-0.0903 -0.01376,-0.18098 -0.01411,-0.27341 0,-1.82209 1.477786,-3.29953 3.299883,-3.29953 1.275645,0 2.379839,0.72496 2.929114,1.78435 5.794021,-1.97485 12.582877,-4.77096 12.582877,-4.77096 0,0 -6.681613,-2.75202 -12.444941,-4.72405 -0.482953,1.22273 -1.672519,2.08915 -3.06705,2.0888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2275",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 26.991575,266.28238 c -1.28905,1.2887 -3.3782,1.2887 -4.666545,0 -0.149225,-0.14887 -0.2794,-0.31009 -0.3937,-0.47801 -0.38735,0.2674 -0.699558,0.51293 -0.915811,0.72954 -2.60985,2.60985 -2.60985,6.84071 0,9.45056 2.60985,2.60985 6.841067,2.61021 9.450563,2.7e-4 0.20955,-0.20955 0.446265,-0.50765 0.70344,-0.87736 -0.06914,-0.0586 -0.137584,-0.11818 -0.202849,-0.18345 -1.288695,-1.28834 -1.288695,-3.37784 0,-4.66619 0.902055,-0.9024 2.195338,-1.17016 3.33234,-0.80962 2.700867,-5.49346 5.524148,-12.27102 5.524148,-12.27102 0,0 -6.670675,2.77847 -12.139789,5.45959 0.522816,1.20614 0.294216,2.65994 -0.691797,3.6456"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2277",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.188263,272.68883 c 0,1.8228 -1.477433,3.29988 -3.299883,3.29952 -0.210257,2.7e-4 -0.416632,-0.0215 -0.616302,-0.0596 -0.08467,0.46284 -0.13194,0.85725 -0.131588,1.16381 0,3.69076 2.991557,6.68231 6.683023,6.68231 3.690409,2.7e-4 6.682669,-2.99155 6.682669,-6.68231 0,-0.29634 -0.04374,-0.67451 -0.123119,-1.11795 -0.09031,0.007 -0.180975,0.0138 -0.273402,0.0141 -1.82245,0 -3.299883,-1.47744 -3.299531,-3.29988 -2.65e-4,-1.27565 0.724958,-2.37949 1.783998,-2.92877 -1.97485,-5.79402 -4.770967,-12.58287 -4.770967,-12.58287 0,0 -2.752021,6.68126 -4.723696,12.44459 1.22273,0.48295 2.08915,1.67287 2.088798,3.06705"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2279",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 48.928355,270.00913 c 1.289402,1.28834 1.28905,3.37749 0,4.66583 -0.148873,0.14923 -0.30974,0.27975 -0.47766,0.39405 0.267403,0.387 0.512937,0.69921 0.729543,0.91546 2.60985,2.60985 6.840712,2.61021 9.450562,0 2.6102,-2.60949 2.6102,-6.84071 0,-9.45056 -0.20955,-0.20955 -0.50765,-0.44626 -0.877,-0.70344 -0.0589,0.0691 -0.11854,0.13758 -0.18345,0.2032 -1.2887,1.28835 -3.3782,1.28835 -4.66619,-2.6e-4 -0.902405,-0.9017 -1.170163,-2.19534 -0.80962,-3.33234 -5.49346,-2.70087 -12.271379,-5.5238 -12.271379,-5.5238 0,0 2.778829,6.67033 5.459587,12.13979 1.205797,-0.52281 2.659947,-0.29421 3.645607,0.69215"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2281",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 55.3348,259.81208 c 1.8228,-2.6e-4 3.30023,1.47708 3.29988,3.29953 2.7e-4,0.21061 -0.0219,0.41663 -0.0596,0.61631 0.46285,0.0847 0.8576,0.13193 1.16381,0.13158 3.69077,0 6.68232,-2.99155 6.68232,-6.68267 2.7e-4,-3.6904 -2.99155,-6.68267 -6.68267,-6.68267 -0.29633,0 -0.67451,0.0437 -1.1176,0.12277 0.007,0.091 0.0138,0.18133 0.0141,0.2734 -2.6e-4,1.82245 -1.47778,3.29989 -3.30023,3.29953 -1.2753,2.7e-4 -2.37949,-0.72496 -2.92841,-1.78364 -5.794022,1.9745 -12.583231,4.77097 -12.583231,4.77097 0,0 6.681611,2.75201 12.444941,4.72369 0.4826,-1.22273 1.67252,-2.08915 3.0667,-2.0888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2283",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 52.6551,248.07164 c 1.2887,-1.28905 3.37785,-1.2887 4.66619,0 0.14922,0.14887 0.2794,0.30974 0.3937,0.47801 0.38735,-0.2674 0.69956,-0.51294 0.91581,-0.7299 2.6102,-2.60985 2.6102,-6.84071 0,-9.45056 -2.6095,-2.60985 -6.840712,-2.60985 -9.450914,0 -0.20955,0.20955 -0.445913,0.508 -0.703088,0.87701 0.06879,0.0593 0.137938,0.11888 0.202849,0.18344 1.288698,1.28905 1.288698,3.3782 0,4.66655 -0.9017,0.90205 -2.195336,1.17016 -3.33234,0.80962 -2.700867,5.49346 -5.524146,12.27138 -5.524146,12.27138 0,0 6.670675,-2.77848 12.140142,-5.45995 -0.523171,-1.20579 -0.294217,-2.65994 0.691797,-3.6456"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2285",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.209953,244.10289 c 0,2.42288 -4.386792,13.07394 -4.386792,13.07394 0,0 -4.387146,-10.65106 -4.387146,-13.07394 0,-2.42288 1.964267,-4.38715 4.387146,-4.38715 2.423229,0 4.386792,1.96427 4.386792,4.38715"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2287",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 33.680595,244.82996 c 1.713087,1.71344 6.142566,12.34723 6.142566,12.34723 0,0 -10.633429,-4.42984 -12.346517,-6.14292 -1.713794,-1.71344 -1.713794,-4.49087 0,-6.20395 1.713088,-1.71345 4.490509,-1.71345 6.203951,-3.5e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2289",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 26.749216,252.79004 c 2.422524,0 13.073945,4.38715 13.073945,4.38715 0,0 -10.651421,4.38679 -13.073945,4.38679 -2.422878,0 -4.387144,-1.96427 -4.386791,-4.38679 0,-2.42324 1.963913,-4.38715 4.386791,-4.38715"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2291",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 27.476644,263.31975 c 1.713088,-1.71309 12.346517,-6.14256 12.346517,-6.14256 0,0 -4.429125,10.63342 -6.142566,12.34651 -1.713442,1.71309 -4.490863,1.71309 -6.203951,0 -1.713794,-1.71344 -1.713794,-4.49051 0,-6.20395"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2293",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 35.436015,270.25113 c 2.65e-4,-2.42288 4.387146,-13.07394 4.387146,-13.07394 0,0 4.387144,10.65106 4.386792,13.07394 0,2.42288 -1.963915,4.38679 -4.38644,4.38679 -2.423231,0 -4.387498,-1.96391 -4.387498,-4.38679"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2295",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 45.96608,269.5237 c -1.713442,-1.71309 -6.142919,-12.34651 -6.142919,-12.34651 0,0 10.633427,4.42912 12.346869,6.14256 1.71344,1.71344 1.71344,4.49086 0,6.20395 -1.713442,1.71344 -4.49086,1.71309 -6.20395,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2297",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 52.8971,261.56398 c -2.42252,0 -13.073939,-4.38679 -13.073939,-4.38679 0,0 10.651419,-4.3875 13.073939,-4.3875 2.42288,2.6e-4 4.3875,1.96426 4.38715,4.38714 0,2.42323 -1.96427,4.38715 -4.38715,4.38715"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2299",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 52.17003,251.03391 c -1.713442,1.71344 -12.346869,6.14328 -12.346869,6.14328 0,0 4.429477,-10.63379 6.142919,-12.34723 1.71309,-1.71309 4.490508,-1.71309 6.20395,0 1.71344,1.71344 1.71344,4.49087 0,6.20395"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2301",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.209953,244.10289 c 0,2.42288 -4.386792,13.0743 -4.386792,13.0743 0,0 -4.387146,-10.65142 -4.387146,-13.0743 0,-2.42288 1.964267,-4.38715 4.387146,-4.38715 2.423229,0 4.386792,1.96427 4.386792,4.38715"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2303",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.553182,246.99355 c 0,-1.19627 0.969433,-2.16606 2.166056,-2.16606 0.137935,0 0.273402,0.0145 0.404635,0.0392 0.05539,-0.30374 0.08608,-0.56268 0.08608,-0.76376 0,-2.42288 -1.963563,-4.38715 -4.386792,-4.38715 -2.422879,0 -4.387146,1.96427 -4.387146,4.38715 0,0.19473 0.02858,0.44273 0.08079,0.73413 0.05962,-0.005 0.119237,-0.01 0.17921,-0.01 1.196623,0 2.166057,0.96979 2.166057,2.16606 0,0.83749 -0.475898,1.56245 -1.170872,1.92264 1.296459,3.804 3.131963,8.26064 3.131963,8.26064 0,0 1.806927,-4.38608 3.101269,-8.16963 -0.802923,-0.31714 -1.371248,-1.09819 -1.371248,-2.01365"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2305",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 33.845695,248.7532 c -0.845963,-0.84596 -0.845963,-2.21756 0,-3.06352 0.09807,-0.0977 0.2032,-0.18309 0.31397,-0.25823 -0.175683,-0.25435 -0.336902,-0.45896 -0.47907,-0.60149 -1.713442,-1.71309 -4.490863,-1.71309 -6.203951,3.5e-4 -1.713794,1.71309 -1.713794,4.49086 -3.44e-4,6.20395 0.137584,0.13758 0.333375,0.2928 0.575734,0.46178 0.0388,-0.0452 0.07761,-0.0903 0.120297,-0.13299 0.846313,-0.84596 2.217559,-0.84632 3.063522,0 0.592312,0.59196 0.76835,1.44109 0.531635,2.18757 3.606093,1.77306 8.055681,3.62656 8.055681,3.62656 0,0 -1.823863,-4.37939 -3.583871,-7.96996 -0.791985,0.34326 -1.746602,0.19332 -2.393595,-0.45402"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2307",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 29.639878,255.44716 c -1.19627,0 -2.166056,-0.96978 -2.165703,-2.16605 -3.44e-4,-0.13864 0.01411,-0.27376 0.0388,-0.40464 -0.303742,-0.0557 -0.563033,-0.0868 -0.763764,-0.0864 -2.422878,0 -4.386791,1.96391 -4.386791,4.38715 -3.44e-4,2.42252 1.963913,4.38714 4.386791,4.38714 0.194381,0 0.442736,-0.0289 0.733425,-0.0808 -0.0046,-0.0596 -0.0085,-0.11888 -0.0088,-0.17956 0,-1.19627 0.970139,-2.16605 2.166055,-2.16605 0.837494,0 1.562452,0.47589 1.922992,1.17122 3.80365,-1.29646 8.260291,-3.13196 8.260291,-3.13196 0,0 -4.386439,-1.80693 -8.169981,-3.10127 -0.316794,0.80257 -1.097844,1.37124 -2.013302,1.37124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2309",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 31.399532,263.1543 c -0.846312,0.84631 -2.21756,0.84596 -3.063521,0 -0.09772,-0.0977 -0.183092,-0.20355 -0.258234,-0.31362 -0.254352,0.17533 -0.459316,0.33655 -0.601133,0.47907 -1.713794,1.71344 -1.713794,4.49051 0,6.20395 1.713088,1.71309 4.490861,1.71344 6.203951,2.7e-4 0.137228,-0.13794 0.292803,-0.33338 0.461785,-0.57609 -0.04551,-0.0384 -0.09067,-0.078 -0.13335,-0.12065 -0.84596,-0.84561 -0.84596,-2.21721 0,-3.06317 0.592315,-0.59231 1.441098,-0.768 2.187575,-0.53128 1.77306,-3.60645 3.626556,-8.05568 3.626556,-8.05568 0,0 -4.378679,1.82386 -7.969604,3.58387 0.343254,0.79163 0.193323,1.74625 -0.454025,2.39324"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2311",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 38.093138,267.36012 c 0,1.19662 -0.969785,2.16605 -2.165702,2.16605 -0.138289,0 -0.274108,-0.0141 -0.404989,-0.0392 -0.05539,0.30374 -0.08643,0.56304 -0.08643,0.76412 0,2.42288 1.964267,4.38679 4.387498,4.38679 2.422525,0 4.386792,-1.96391 4.386792,-4.38679 0,-0.19473 -0.02857,-0.44309 -0.08043,-0.73413 -0.05962,0.005 -0.11924,0.009 -0.179565,0.009 -1.196621,0 -2.166409,-0.96978 -2.166409,-2.16605 0,-0.83714 0.47625,-1.5621 1.171575,-1.92264 -1.296458,-3.80365 -3.132312,-8.26029 -3.132312,-8.26029 0,0 -1.806575,4.38608 -3.100916,8.16962 0.802568,0.3168 1.371245,1.09785 1.370893,2.01331"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2313",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 45.800628,265.60081 c 0.84596,0.84597 0.84596,2.21721 0,3.06317 -0.09772,0.0977 -0.2032,0.18345 -0.313973,0.25859 0.175683,0.254 0.336902,0.45932 0.479425,0.60113 1.71309,1.71309 4.490508,1.71344 6.20395,0 1.71344,-1.71309 1.71344,-4.49086 0,-6.20395 -0.13758,-0.13793 -0.333375,-0.29316 -0.575733,-0.46178 -0.03881,0.0451 -0.07796,0.0903 -0.12065,0.13299 -0.845609,0.84596 -2.217561,0.84596 -3.063169,0 -0.592315,-0.59196 -0.767998,-1.44109 -0.531283,-2.18757 -3.606448,-1.77306 -8.056034,-3.6262 -8.056034,-3.6262 0,0 1.824212,4.37903 3.584221,7.96925 0.791633,-0.34326 1.74625,-0.19333 2.393246,0.45437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2315",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 50.006445,258.90685 c 1.196268,-2.6e-4 2.166405,0.96979 2.166055,2.16606 2.6e-4,0.13829 -0.0141,0.2734 -0.0392,0.40464 0.30409,0.0557 0.56303,0.0868 0.76376,0.0864 2.42288,0 4.38715,-1.96392 4.38715,-4.38715 2.6e-4,-2.42288 -1.96427,-4.38714 -4.38715,-4.38714 -0.19473,0 -0.44309,0.0289 -0.73377,0.0808 0.005,0.0596 0.009,0.11923 0.01,0.17956 -2.7e-4,1.19627 -0.970144,2.16605 -2.166412,2.16605 -0.837497,0 -1.562455,-0.47589 -1.92264,-1.17122 -3.804002,1.29646 -8.260644,3.13232 -8.260644,3.13232 0,0 4.386086,1.80657 8.169979,3.10091 0.316442,-0.80257 1.097846,-1.3716 2.013305,-1.37125"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2317",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 48.24714,251.19972 c 0.845963,-0.84632 2.217563,-0.84632 3.063171,0 0.09807,0.0977 0.183444,0.2032 0.258586,0.31362 0.254,-0.17569 0.458963,-0.33655 0.601133,-0.47943 1.71344,-1.71308 1.71344,-4.49051 0,-6.20395 -1.713442,-1.71309 -4.49086,-1.71344 -6.204302,0 -0.137583,0.13759 -0.292455,0.33373 -0.461788,0.57609 0.04516,0.0388 0.09067,0.0776 0.13335,0.1203 0.846315,0.84631 0.846315,2.21756 0,3.06352 -0.592312,0.59196 -1.441095,0.768 -2.187575,0.53128 -1.77306,3.60645 -3.626554,8.05604 -3.626554,8.05604 0,0 4.379384,-1.82422 7.969602,-3.58458 -0.343252,-0.79128 -0.192968,-1.7459 0.454377,-2.39289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2319",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 42.48487,249.24498 c 0,1.47002 -2.661709,7.93185 -2.661709,7.93185 0,0 -2.661708,-6.46183 -2.661708,-7.93185 0,-1.47003 1.192035,-2.66171 2.661708,-2.66171 1.470377,0 2.661709,1.19168 2.661709,2.66171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2321",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 36.096415,249.6863 c 1.039283,1.03929 3.726746,7.49053 3.726746,7.49053 0,0 -6.451248,-2.68711 -7.490883,-3.72674 -1.039283,-1.03929 -1.039283,-2.7245 0,-3.76379 1.039635,-1.03963 2.724854,-1.03963 3.764137,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2323",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 31.891305,254.51548 c 1.469673,0 7.931856,2.66135 7.931856,2.66135 0,0 -6.462183,2.66171 -7.931856,2.66171 -1.470025,0 -2.66206,-1.19168 -2.661708,-2.66171 0,-1.47002 1.191683,-2.66135 2.661708,-2.66135"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2325",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 32.332278,260.90358 c 1.039635,-1.03929 7.490883,-3.72675 7.490883,-3.72675 0,0 -2.687463,6.4516 -3.726746,7.49089 -1.039283,1.03928 -2.724502,1.03928 -3.764137,0 -1.039283,-1.03964 -1.039283,-2.72451 0,-3.76414"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2327",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.161453,265.10904 c 2.65e-4,-1.47002 2.661708,-7.93221 2.661708,-7.93221 0,0 2.661709,6.46219 2.661709,7.93221 0,1.46967 -1.191684,2.66136 -2.661357,2.66136 -1.470377,0 -2.66206,-1.19169 -2.66206,-2.66136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2329",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.549905,264.66772 c -1.039283,-1.03929 -3.726744,-7.49089 -3.726744,-7.49089 0,0 6.451246,2.68746 7.490884,3.72675 1.039283,1.03963 1.039283,2.72485 0,3.76378 -1.039638,1.03999 -2.724857,1.03964 -3.76414,2.7e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2331",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 47.755015,259.83854 c -1.46967,0 -7.931854,-2.66171 -7.931854,-2.66171 0,0 6.462184,-2.66135 7.931854,-2.66135 1.470025,0 2.662063,1.19168 2.661708,2.66135 0,1.47003 -1.191683,2.66171 -2.661708,2.66171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2333",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 47.314045,253.45009 c -1.039638,1.03928 -7.490884,3.72674 -7.490884,3.72674 0,0 2.687461,-6.45124 3.726744,-7.49088 1.039283,-1.03928 2.724502,-1.03928 3.76414,0 1.039283,1.03964 1.039283,2.72485 0,3.76414"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2335",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 42.48487,249.24498 c 0,1.47002 -2.661709,7.93185 -2.661709,7.93185 0,0 -2.661708,-6.46183 -2.661708,-7.93185 0,-1.47003 1.192035,-2.66171 2.661708,-2.66171 1.470377,0 2.661709,1.19168 2.661709,2.66171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2337",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 40.872673,250.99864 c 0,-0.72567 0.588082,-1.3141 1.314099,-1.3141 0.08396,0 0.166158,0.009 0.245533,0.024 0.03387,-0.1845 0.05257,-0.34148 0.05257,-0.46355 0,-1.47002 -1.191332,-2.6617 -2.661709,-2.6617 -1.469673,0 -2.661708,1.19168 -2.661708,2.6617 0,0.11819 0.01765,0.26847 0.04868,0.44521 0.03634,-0.003 0.07267,-0.006 0.109361,-0.006 0.726016,0 1.314098,0.58843 1.314098,1.31409 0,0.508 -0.288925,0.94792 -0.710497,1.16664 0.786342,2.30752 1.900063,5.01156 1.900063,5.01156 0,0 1.096079,-2.661 1.881717,-4.95653 -0.487188,-0.19226 -0.832205,-0.66604 -0.832205,-1.22167"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2339",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 36.196605,252.06649 c -0.513292,-0.51329 -0.513292,-1.34549 0,-1.85878 0.05927,-0.0593 0.123473,-0.11113 0.1905,-0.15699 -0.10654,-0.15416 -0.20461,-0.27834 -0.29069,-0.36442 -1.039283,-1.03963 -2.724502,-1.03963 -3.764137,0 -1.039283,1.03929 -1.039283,2.7245 0,3.76379 0.08396,0.0836 0.202494,0.1778 0.349602,0.28046 l 0.07303,-0.0811 c 0.513292,-0.51294 1.345142,-0.51329 1.858433,0 0.359482,0.35948 0.466019,0.87453 0.32244,1.3275 2.187927,1.07562 4.887383,2.19992 4.887383,2.19992 0,0 -1.106664,-2.65677 -2.174171,-4.83517 -0.480483,0.20849 -1.059743,0.11748 -1.452385,-0.27517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2341",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 33.644963,256.12732 c -0.726016,0 -1.314098,-0.58808 -1.314098,-1.3141 0,-0.084 0.0088,-0.1658 0.024,-0.24553 -0.184502,-0.0339 -0.341842,-0.0522 -0.46355,-0.0522 -1.470025,0 -2.661709,1.19133 -2.661709,2.66135 -2.64e-4,1.47003 1.191684,2.66171 2.661709,2.66171 0.117827,0 0.268465,-0.0173 0.444852,-0.049 -0.0028,-0.036 -0.0053,-0.072 -0.0053,-0.10865 0,-0.72566 0.588433,-1.3141 1.314098,-1.3141 0.508,0 0.947915,0.28858 1.166635,0.7105 2.307873,-0.7867 5.011563,-1.90042 5.011563,-1.90042 0,0 -2.661004,-1.09573 -4.956529,-1.88136 -0.192262,0.48718 -0.666396,0.83185 -1.221669,0.83185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2343",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 34.71247,260.80339 c -0.513292,0.51329 -1.345142,0.51329 -1.858434,0 -0.05927,-0.0593 -0.111479,-0.12347 -0.156988,-0.1905 -0.154162,0.10654 -0.278693,0.20426 -0.36477,0.29069 -1.039283,1.03963 -1.039283,2.7245 0,3.76414 1.039635,1.03928 2.724854,1.03963 3.764137,0 0.08361,-0.0833 0.177448,-0.20214 0.280107,-0.34925 l -0.08043,-0.073 c -0.513291,-0.51329 -0.513291,-1.34549 0,-1.85879 0.358775,-0.35912 0.873832,-0.46566 1.326798,-0.32243 1.075619,-2.18793 2.200275,-4.88739 2.200275,-4.88739 0,0 -2.656771,1.10667 -4.834821,2.17452 0.207788,0.48049 0.117123,1.0594 -0.27587,1.45204"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2345",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 38.773647,263.35503 c 0,0.72602 -0.588434,1.3141 -1.314099,1.3141 -0.08396,0 -0.166158,-0.008 -0.245533,-0.0236 -0.03387,0.18415 -0.05256,0.34149 -0.05256,0.46355 0,1.46967 1.191683,2.66135 2.66206,2.66135 1.469673,0 2.661357,-1.19168 2.661357,-2.66135 0,-0.11818 -0.01728,-0.26882 -0.04904,-0.44521 -0.03598,0.003 -0.07197,0.005 -0.109009,0.005 -0.725662,0 -1.313743,-0.58843 -1.313743,-1.31409 0,-0.508 0.288573,-0.94756 0.710142,-1.16629 -0.786342,-2.30787 -1.900061,-5.01191 -1.900061,-5.01191 0,0 -1.096081,2.66136 -1.881364,4.95653 0.487185,0.19261 0.832201,0.6664 0.83185,1.22167"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2347",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.449715,262.28752 c 0.513292,0.5133 0.513292,1.3455 0,1.85844 -0.05927,0.0596 -0.12347,0.11148 -0.1905,0.15698 0.106892,0.15417 0.204613,0.2787 0.29069,0.36478 1.039283,1.03928 2.724502,1.03963 3.76414,-2.7e-4 1.039283,-1.03893 1.039283,-2.72415 0,-3.76378 -0.08326,-0.0833 -0.202142,-0.17745 -0.34925,-0.28011 l -0.07338,0.0811 c -0.512937,0.51294 -1.345493,0.51294 -1.858433,0 -0.359127,-0.35948 -0.466019,-0.87454 -0.322437,-1.3275 -2.18793,-1.07562 -4.887384,-2.20028 -4.887384,-2.20028 0,0 1.106662,2.65677 2.174521,4.83517 0.480131,-0.20813 1.059746,-0.11712 1.452033,0.27552"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2349",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 46.001357,258.2267 c 0.726016,-2.6e-4 1.314098,0.58808 1.314098,1.31374 0,0.084 -0.0085,0.16616 -0.02363,0.24554 0.18415,0.0339 0.341487,0.0526 0.463195,0.0526 1.470025,0 2.661708,-1.19168 2.661708,-2.66171 2.65e-4,-1.46967 -1.191683,-2.66135 -2.661708,-2.66135 -0.117827,0 -0.268817,0.0173 -0.445204,0.0487 0.0032,0.0363 0.0056,0.0723 0.0056,0.10901 0,0.72566 -0.588433,1.3141 -1.314098,1.3141 -0.508,0 -0.947912,-0.28858 -1.166284,-0.7105 -2.30787,0.78634 -5.011912,1.90006 -5.011912,1.90006 0,0 2.661354,1.09608 4.956527,1.88172 0.192265,-0.48719 0.666398,-0.8322 1.221669,-0.83185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2351",
    style: {
      fill: "#a5861e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.933853,253.55063 c 0.513292,-0.51364 1.345142,-0.51329 1.858785,0 0.05927,0.0593 0.111125,0.12312 0.156634,0.19015 0.154164,-0.10654 0.278693,-0.20426 0.364773,-0.29069 1.039283,-1.03929 1.039283,-2.7245 0,-3.76414 -1.039638,-1.03928 -2.724857,-1.03928 -3.76414,2.6e-4 -0.08326,0.0833 -0.1778,0.20215 -0.280107,0.34925 l 0.08079,0.073 c 0.513292,0.51329 0.513292,1.34549 0,1.85843 -0.359481,0.35948 -0.874183,0.46602 -1.32715,0.32244 -1.075973,2.18793 -2.200275,4.88739 -2.200275,4.88739 0,0 2.656769,-1.10667 4.835525,-2.17453 -0.208491,-0.48013 -0.117475,-1.05904 0.275167,-1.45168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2353",
    style: {
      fill: "#3a2e16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.673855,257.17683 c 0,2.679 -2.172052,4.8507 -4.850694,4.8507 -2.678996,0 -4.850696,-2.1717 -4.850696,-4.8507 0,-2.67899 2.1717,-4.85069 4.850696,-4.85069 2.678642,0 4.850694,2.1717 4.850694,4.85069"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower3);
export default __webpack_public_path__ + "static/media/flower-3.0a8cabd37e810b5f4d7bf43144f61165.svg";
export { ForwardRef as ReactComponent };